import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';

export const ArrowDownThree = Styled(
	createSvgIcon(
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M12.0467 9.61999L8.00004 13.6667L3.95337 9.61999'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeMiterlimit='10'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M8 2.33334V13.5533'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeMiterlimit='10'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>,
		'ArrowDownThree'
	)
);

export default ArrowDownThree;
